export const PHONE_DISPLAY = "1300 385 767";
export const PHONE_TEL = "1300385767";

export const LOGO_ICON =
  "https://customer-assets-agu9un31.emergentagent.net/job_fuel-emergency-aid/artifacts/kwr8jv0t_download.png";

export const SUBURBS = [
  "Sydney CBD", "North Sydney", "Parramatta", "Bondi", "Manly", "Chatswood",
  "Cronulla", "Penrith", "Liverpool", "Bankstown", "Ryde", "Hornsby",
  "Sutherland", "Blacktown", "Castle Hill", "Randwick", "Newtown", "Mascot",
  "Hurstville", "Campbelltown", "Dee Why", "Epping", "Strathfield", "Rockdale",
];

export const REVEAL = {
  hidden: { opacity: 0, y: 22 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};
